import React, { useState, useEffect, useContext, Fragment } from "react";
import { NavLink } from "react-router-dom";
import { AppContext } from "../Utils/AppContext";
import Page from "../Layout/Page";
import FleetTable from "../Tables/FleetTable";
import UserTable from "../Tables/UserTable";
import { useGetCompany, useGetAllCompanies, updateCompanyThresholdValues } from "../Utils/Company";
import { FleetFormCreate } from "../Forms/FleetForm";
import UserForm from "../Forms/UserForm";

// eslint-disable-next-line react/prop-types
const CompanyDetails = ({ route, isHome }) => {
  const context = useContext(AppContext);
  const currentUser = context.state.user;

  let companyId;

  if (isHome) {
    companyId = currentUser.company.id;
  } else {
    companyId = route.params.companyId;
  }
  // eslint-disable-next-line prefer-destructuring
  const [showUserForm, setShowUserForm] = useState(false);
  const [showFleetForm, setShowFleetForm] = useState(false);
  const [managerThreshold, setManagerThreshold] = useState("");
  const [fleetThreshold, setFleetThreshold] = useState("");
  const [driverThreshold, setDriverThreshold] = useState("");

  const { loading: loadingCompany, company: companyInfo } = useGetCompany(companyId);

  useEffect(() => {
    if (!loadingCompany) {
      setManagerThreshold(companyInfo.settings.notificationThreshold.companyManager);
      setFleetThreshold(companyInfo.settings.notificationThreshold.fleetManager);
      setDriverThreshold(companyInfo.settings.notificationThreshold.driver);
    }
  }, [loadingCompany]);

  return (
    <Fragment>
      {!loadingCompany && (
        <Page title={companyInfo.name}>
          <form>
            <label htmlFor="companyManagerThreshold">
              Low energy threshold for company manager notifications:
              <input
                type="text"
                name="companyManagerThreshold"
                id="companyManagerThreshold"
                onChange={event => setManagerThreshold(event.target.value)}
                value={managerThreshold}
              />
            </label>
            <br />
            <label htmlFor="fleetManagerThreshold">
              Low energy threshold for fleet manager notifications:
              <input
                type="text"
                name="fleetManagerThreshold"
                id="fleetManagerThreshold"
                onChange={event => setFleetThreshold(event.target.value)}
                value={fleetThreshold}
              />
            </label>
            <br />
            <button
              onClick={() => updateCompanyThresholdValues(companyId, managerThreshold, fleetThreshold, driverThreshold)}
              type="button"
            >
              Update Threshold Values
            </button>
          </form>

          <br />
          {currentUser.role === "super" && (
            <div>
              <FleetTable title="Fleets" hideCompany companyId={companyId} />
              <br />
              <UserTable title="Users" hideCompany companyId={companyId} />
            </div>
          )}

          {currentUser.role !== "super" && (
            <div>
              <UserTable hideCompany companyId={companyId} hideEnergy title="Managers" userRole="managers" />
              <br />
              {showUserForm && (
                <Fragment>
                  <br />
                  <UserForm
                    cid={companyId}
                    formComplete={() => {
                      setShowUserForm(false);
                    }}
                  />

                  <button
                    type="button"
                    onClick={() => {
                      setShowUserForm(false);
                    }}
                  >
                    Cancel
                  </button>
                </Fragment>
              )}

              {!showUserForm && (
                <Fragment>
                  <button
                    type="button"
                    onClick={() => {
                      setShowUserForm(true);
                    }}
                  >
                    Add User
                  </button>
                </Fragment>
              )}
            </div>
          )}
        </Page>
      )}
    </Fragment>
  );
};

export default CompanyDetails;
